<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    bottom
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :placeholder="placeholder"
        :label="label"
        outlined
        v-model="dateInternal"
        append-icon="mdi-alarm"
        class="vuetify"
        v-bind="attrs"
        v-on="on"
        @input="saved(dateInternal)"
        :error="messageError && messageError.length > 0 ? true : false"
        :error-messages="messageError"

      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      v-model="dateInternal"
      format="24hr"
      full-width
      @click:minute="saved(dateInternal)"
    ></v-time-picker>
  </v-menu>
</template>

<script>

export default {
  name: 'HourPicker',
  props: [
    'binding',
    'label',
    'messageError',
    'placeholder',
    'data-cy'
  ],
  data () {
    return {
      menu: false,
      dateInternal: null,
    }
  },

  methods: {
    saved (value) {
      let myDate = value;
      this.menu = false
      this.$emit('update:binding', myDate)
    },
  },
  watch: {
    binding: function(value, oldValue) {
      if (value != oldValue) {
        this.dateInternal = value
      }
    },
    dateInternal(val) {
      if(val.split("").length === 2) {
        this.dateInternal = val + ":";
      }
    }
  },
  mounted () {
    if (this.binding) {
      this.dateInternal = this.binding
    }
  }
};
</script>
